import { Check } from "lucide-react";

// Polished "positive" marker: glossy emerald disc with a crisp white tick
export const GoodCheck = ({ className = "h-6 w-6" }) => (
  <span
    className={`${className} inline-flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 text-white shadow-[0_2px_6px_rgba(16,185,129,0.45)] ring-2 ring-emerald-400/25`}
    aria-hidden="true"
  >
    <Check className="h-[60%] w-[60%]" strokeWidth={3.5} />
  </span>
);
